import { Box } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledViewOrderIdsTableContainer = styled(Box, {
  border: '$borderWidths$1 solid $colors$seafoam500',
  borderRadius: '$4',
  padding: '$0 $8',
});

export const PaginationContainerStyled = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: '$4 $0',
  '@sm': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
